import ArticleSuggestionsManager from '../../services/article-suggestions-manager/article-suggestions-manager';

import CacheService from '../cache-service';

class ArticlesService extends CacheService {
  getFullArticles() {
    return this.getCachedData('/api/articles');
  }

  getFullArticleById(id) {
    return this.getCachedData(`/api/articles/${id}`);    
  }

  getArticlesSummaries() {
    return this.getCachedData('/api/articles-summaries')
      .then(articles => {
        ArticleSuggestionsManager.Articles = [...articles].reverse();
        return articles;
      });
  }  
}

const articlesService = new ArticlesService();

export default articlesService;